import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL = '[IncidentsModul] GetIncidentCheckByFunkprotokollFall laden';
export const GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL_AUSFUEHREN = '[IncidentsModul] GetIncidentCheckByFunkprotokollFall ausführen';
export const GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL_ERFOLGREICH = '[IncidentsModul] GetIncidentCheckByFunkprotokollFall laden erfolgreich';
export const GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL_FEHLER = '[IncidentsModul] GetIncidentCheckByFunkprotokollFall Ladefehler';
export const GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL_NICHT_AUSGEFUEHRT = '[IncidentsModul] GetIncidentCheckByFunkprotokollFall nicht ausgeführt (evtl. Offline)';


export class GetIncidentCheckByFunkprotokollFallAction implements Action {
    readonly type = GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL;
        constructor( public fall_id:string , public optPayload: any = null) {}
    }
export class GetIncidentCheckByFunkprotokollFallAusfuehrenAction implements Action {
    readonly type = GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL_AUSFUEHREN;
        constructor( public fall_id:string , public optPayload: any = null) {}
    }
export class GetIncidentCheckByFunkprotokollFallErfolgreichAction implements Action {
    readonly type = GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL_ERFOLGREICH;
        constructor(public payload: api.IndicentCheck,  public fall_id:string , public optPayload: any = null) {}
    }
export class GetIncidentCheckByFunkprotokollFallFehlerAction implements Action {
    readonly type = GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL_FEHLER;
        constructor(public payload: any,  public fall_id:string , public optPayload: any = null) {}
    }
export class GetIncidentCheckByFunkprotokollFallNichtAusgefuehrtAction implements Action {
    readonly type = GET_INCIDENT_CHECK_BY_FUNKPROTOKOLL_FALL_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsQueryIncidentCheckByFunkprotokollFallActions =
    GetIncidentCheckByFunkprotokollFallAction
    | GetIncidentCheckByFunkprotokollFallAusfuehrenAction
    | GetIncidentCheckByFunkprotokollFallErfolgreichAction
    | GetIncidentCheckByFunkprotokollFallFehlerAction
    | GetIncidentCheckByFunkprotokollFallNichtAusgefuehrtAction
    ;
